import { useState, FunctionComponent, useRef, useEffect } from "react";
import { LoadingSpinner } from "../generic";
import WideTile from "../generic/tiles/WideTile";
import { Client } from "src/utils/types/UserTypes";
import { analysis, informativ } from "src/utils";
import MAPReportViewer from "./MAPReportViewer";
import { masterId, masterPassword } from "../../utils/secrets";

interface IAutoMapProps {
  client: Client;
  ssn: string;
}

const AutoMap: FunctionComponent<IAutoMapProps> = ({ client, ssn }) => {
  const iframeRefReportA = useRef(null);
  const iframeRefReportB = useRef(null);
  const iframeRefReportC = useRef(null);

  const refs = [iframeRefReportA, iframeRefReportB, iframeRefReportC];

  const [creditReportType, _] = useState<informativ.types.CreditUnions>(
    informativ.types.CreditUnions.TRI_MERGE
  );
  const [creditReport, setCreditReport] = useState<any>(null);
  const [scoreCardReports, setScoreCardReports] = useState<Record<any, any>>(
    []
  );
  const [loading, setLoading] = useState(false);
  const [reportASummary, setReportASummary] = useState<Record<any, any> | null>(
    null
  );
  const [reportBSummary, setReportBSummary] = useState<Record<any, any> | null>(
    null
  );
  const [reportCSummary, setReportCSummary] = useState<Record<any, any> | null>(
    null
  );
  const [riskReport, setRiskReport] = useState<Record<any, any> | null>(null);
  const [pastDue, setPastDue] = useState<number | null>(null);

  useEffect(() => {
    if (!reportASummary && !reportBSummary && !reportCSummary) pullCredit();
  }, []);

  useEffect(() => {
    if (scoreCardReports.length && iframeRefReportA.current) {
      setTimeout(
        () =>
          analysis.finance.analyzeReport(iframeRefReportA, setReportASummary),
        2000
      );
    }
  }, [scoreCardReports, iframeRefReportA]);

  useEffect(() => {
    if (scoreCardReports.length && iframeRefReportB.current) {
      setTimeout(
        () =>
          analysis.finance.analyzeReport(iframeRefReportB, setReportBSummary),
        2000
      );
    }
  }, [scoreCardReports, iframeRefReportB]);

  useEffect(() => {
    if (scoreCardReports.length && iframeRefReportC.current) {
      setTimeout(
        () =>
          analysis.finance.analyzeReport(iframeRefReportC, setReportCSummary),
        2000
      );
    }
  }, [scoreCardReports, iframeRefReportC]);

  useEffect(() => {
    if (reportASummary && reportBSummary && reportCSummary) {
      const pastDueResult = analysis.extract.extractPastDueTotal(
        reportASummary,
        reportBSummary,
        reportCSummary
      );
      const riskReportResult = analysis.extract.runRiskAnalysis(
        reportASummary,
        reportBSummary,
        reportCSummary
      );

      setRiskReport(riskReportResult);
      setPastDue(pastDueResult);
    }
  }, [reportASummary, reportBSummary, reportCSummary]);

  const pullCredit = async () => {
    setLoading(true);
    if(!masterPassword || !masterId) {
      setLoading(false);
      return;
    }

    try {
      const result = await informativ.creditPulls.intialCreditPull(
        client,
        ssn,
        masterPassword,
        masterId
      );

      //@ts-ignore
      const app_id = result["XML_INTERFACE"]["APP_ID"]["_text"]
        .replace("{", "")
        .replace("}", "");

      const BUREAU_TYPE =
        //@ts-ignore
        result["XML_INTERFACE"]["CREDITREPORT"]["BUREAU_TYPE"];
      let credit_guid;

      if (Array.isArray(BUREAU_TYPE)) {
        credit_guid = BUREAU_TYPE;
      } else {
        //@ts-ignore
        credit_guid = BUREAU_TYPE["CREDIT_GUID"]["_text"];
      }

      await analysis.finance.parseCreditReport(result, setScoreCardReports);

      setCreditReport(result);
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  console.log({ reportASummary, reportBSummary, reportCSummary, creditReport });

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        creditReport &&
        !loading && (
          <>
            <MAPReportViewer
              client={client}
              reportASummary={reportASummary}
              reportBSummary={reportBSummary}
              reportCSummary={reportCSummary}
              pastDue={typeof pastDue === "number" ? pastDue : -1}
              riskReport={riskReport || {}}
              creditReportType={creditReportType}
              scoreCards={scoreCardReports}
              saveOnLoad={true}
            />

            <div>
              {scoreCardReports.map(
                (scoreCard: Record<any, any>, index: number) => (
                  <div className="mx-4">
                    <iframe
                      key={scoreCard.score}
                      ref={refs[index]}
                      srcDoc={scoreCard.report}
                      style={{
                        width: "5px",
                        height: "5px",
                        border: "none",
                        opacity: 0,
                      }}
                    />
                  </div>
                )
              )}
            </div>

            <WideTile>
              <iframe
                srcDoc={
                  creditReport["XML_INTERFACE"]["CREDITREPORT"]["REPORT"][
                    "_cdata"
                  ]
                }
                style={{ width: "100%", height: "500px", border: "none" }}
              />
            </WideTile>
          </>
        )
      )}
    </>
  );
};
export default AutoMap;
